import { Link } from 'react-router-dom';

const AccessDeniedPage = () => {
  return (
    <div className="errors-content">
      <div className="errors-body">
        <div className="errors-title">403</div>
        <div className="errors-desc">Доступ запрещён</div>
      </div>

      <Link to={`/`} className="at-btn at-btn-medium">
        На главную
      </Link>
    </div>
  );
};

export default AccessDeniedPage;
